import classNames from 'classnames'

import { TEST_COLLECTION_NAME, IPFS_URL } from '../../../app/constants'
import { Check, Cross } from '../../../assets/img'

const StakeCard = ({
  image,
  name,
  video,
  mint,
  assetId,
  isStaked,
  notInUserWallet,
  handleCardStake,
  handleCardUnstake,
  disabled,
}) => {
  return (
    <div className="flex flex-col w-full md:w-[30%] lg:w-[280px]">
      {mint && (
        <p className="text-gold text-right font-medium self-end">#{mint}</p>
      )}
      <div
        className={
          notInUserWallet ? 'col-span-2 filter grayscale ' : 'col-span-2'
        }
      >
        {video ? (
          <video autoPlay loop muted src={`${IPFS_URL}${video}`}></video>
        ) : (
          <img alt={name} src={`${IPFS_URL}${image}`} loading="lazy"></img>
        )}
      </div>
      <div>
        {/* <h3 className="text-white">{name}</h3>
        <dl>
          <dt className="text-gold">Total MP:</dt>
          <dd></dd>
        </dl> */}
        <div className="text-cyanBlue flex justify-center">
          {notInUserWallet ? (
            <div className="flex gap-2 w-4/5">
              <a
                href={`https://wax.atomichub.io/explorer/template/galaktikanft/${assetId}`}
                target="_blank"
                rel="noreferrer"
                className="flex flex-grow items-center justify-center uppercase mt-3  text-white hover:bg-cyanBlue hover:text-black cursor-pointer py-1.5 2xl:py-2 rounded border border-cyanBlue transition-all duration-300"
              >
                NB
              </a>
              <a
                href={`https://wax-test.atomichub.io/explorer/template/${TEST_COLLECTION_NAME}/${assetId}`}
                target="_blank"
                rel="noreferrer"
                className="flex flex-grow items-center justify-center uppercase mt-3 text-white hover:bg-cyanBlue hover:text-black cursor-pointer py-1.5 2xl:py-2 rounded border border-cyanBlue transition-all duration-300"
              >
                AH
              </a>
            </div>
          ) : isStaked ? (
            <button
              onClick={handleCardUnstake}
              className="h-10 w-10 border border-cyanBlue bg-cyanBlue text-black hover:bg-transparent hover:text-cyanBlue transition-all duration-300 rounded-md mt-3"
            >
              <Check />
            </button>
          ) : (
            <button
              disabled={disabled}
              onClick={handleCardStake}
              className={classNames(
                disabled ? 'opacity-80' : 'hover:bg-cyanBlue hover:text-black',
                'h-10 w-10 border border-cyanBlue transition-all duration-300 rounded-md mt-3',
              )}
            >
              <Cross />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StakeCard
